import { computeBidders } from "./bids";
import {
  VideoLinearity,
  VideoPlacement,
  VideoPlacementV2,
  VideoPlaybackMethod,
  VideoProtocol,
  VideoSkip,
} from "./enums";

export const requestBids = (slot: googletag.Slot) => {
  const adUnit: pbjs.AdUnit = {
    bids: computeBidders(),
    code: slot.getSlotElementId(),
    mediaTypes: {
      banner: {
        sizes: [
          [300, 250],
          [1, 1],
        ],
      },
      video: {
        api: [],
        context: "outstream",
        h: 480,
        linearity: VideoLinearity.NonLinear,
        maxduration: 30,
        mimes: [
          "video/webm",
          "application/javascript",
          "video/mp4",
          "application/x-mpeg",
          "application/x-mpegURL",
        ],
        placement: VideoPlacement.InArticle,
        playbackmethod: [VideoPlaybackMethod.PageLoadWithSoundOff],
        playerSize: [640, 480],
        plcmt: VideoPlacementV2.NoContentOrStandalone,
        protocols: [
          VideoProtocol.VAST1,
          VideoProtocol.VAST2,
          VideoProtocol.VAST3,
          VideoProtocol.VAST1Wrapper,
          VideoProtocol.VAST2Wrapper,
          VideoProtocol.VAST3Wrapper,
          VideoProtocol.VAST4,
          VideoProtocol.VAST4Wrapper,
        ],
        skip: VideoSkip.Yes,
        w: 640,
      },
    },
  };

  const cleanup = () => {
    pbjs.que.push(() => {
      pbjs.removeAdUnit([adUnit.code]);
    });
  };

  const result = new Promise<pbjs.BidsResponse>((resolve, reject) => {
    pbjs.que.push(async () => {
      pbjs.addAdUnits(adUnit);
      try {
        const response = await pbjs.requestBids({ adUnitCodes: [adUnit.code] });
        pbjs.setTargetingForGPTAsync([adUnit.code]);
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  });

  return { cleanup, result };
};
